/*eslint-disable*/
import GameStatsApi from '../../api/games/gameStat';
import GameExerciseApi from '../../api/games/gameExercise';
import { mapState } from 'vuex';
import _ from 'lodash';
import settings from '../../config/trainer';
import handleDigitInput from "./handleDigitInput";

const SEND_EXAMPLE_GAMES = ['MultiplicationAndDivision', 'MultiplicationAndDivisionMathMagic', 'TabularMultiplication', 'EquationMultiplication'];

function DEFAULT_DATA () {
    return {
        gameStat: null,
        answers: {
            good: 0,
            bad: 0,
        },
        exercise: null,
        initialAmountOfActions: null,
        initialSpeed: null
    }
}

export default {
    data() {
        return {
            gameStat: null,
            answers: {
                good: 0,
                bad: 0,
            },
            exercise: null,
            initialAmountOfActions: null,
            initialSpeed: null
        };
    },
    watch: {
        user(val){
            if (val && this.exercise) {
                this.setParameters();
            }
        },
        exercise(val) {
            if (val && this.user) {
                this.setParameters();
            }
        },
    },
    methods: {
        handleDigitInput,
        setParameters() {
            this.parameters = this.exercise.parameters['default'];
            for (let key in this.exercise.parameters) {
                if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                    this.parameters = this.exercise.parameters[key];
                    this.isLoading = false;
                    break;
                }
            }
            this.$store.dispatch('setGame', _.cloneDeep(this.parameters));
        },
        createStat () {
            let course = '';
            if (this.exercise) {
                course = this.exercise.courseType;
            } else if (this.parameters) {
                course = _.kebabCase(this.parameters.courseType);
            }

            let stat = {
                parameters: this.parameters,
                game: this.type || this.parameters.game,
                course,
                userId: this.user.id,
                attempts: 0,
                gameExerciseId: this.exercise && this.exercise.sourceType === 'olympiadLevelTrainerStage' ? undefined : this.exerciseId
            };
            this.initialAmountOfActions = this.parameters.amountOfActions;
            this.initialSpeed = this.parameters.speed;
            return GameStatsApi.create(stat);
        },
        assignData (data) {
            if (data.homework) {
                this.$store.dispatch('setHomework', data.homework);
                delete data.homework;
            }
            let stat = _.find(data.stats, {userId: this.user.id});
            this.gameStat = stat;
            this.time = data.stats.length > 0 ?
                stat.executionTime || 0 : 0;
            this.points = data.stats.length > 0 ?
                stat.points || 0 : 0;
            this.exercise = data;
            this.answers.good = this.exercise.correctAnswers || 0;
            this.answers.bad = this.exercise.wrongAnswers || 0;
        },
        assignParameters (data) {
            let defaultSettings = _.find(settings.games, {slug: data.slug}).parameters.default.extraOptions;
            this.parameters = this.exercise.parameters.default;
            for (let key in this.exercise.parameters) {
                if (key !== 'default' && key.match(/[\d]*[\d]+/g).some(userId => +userId === this.user.id)) {
                    this.parameters = this.exercise.parameters[key];
                    break;
                }
            }
            defaultSettings && (
                this.parameters.extraOptions = Object.assign({}, defaultSettings, this.parameters.extraOptions)
            );
            this.$store.dispatch('setGame', _.cloneDeep(this.parameters));
            if (!this.gameStat) {
                return this.createStat();
            }
            return this.gameStat;
        },
        assignDataForLoner(data) {
            let parameters = data;
            parameters = parameters['usersU' + this.user.id] || parameters.default;
            this.lonerData = parameters;
        },
        fetchData() {
            return new Promise((resolve, reject) => {
                if (this.exerciseId && !this.inPuzzle) {
                    this.isLoading = true;
                    GameExerciseApi.show(this.exerciseId)
                        .then((data) => {
                            let parameters = data.parameters;
                            parameters = parameters['user' + this.user.id] || parameters.default;
                            this.assignDataForLoner(data.parameters);
                            this.initialAmountOfActions = parameters.amountOfActions;
                            this.initialSpeed = parameters.speed;
                            this.assignData(data);
                            return this.assignParameters(data);
                        })
                        .then(stat => {
                            stat && (this.gameStat = stat);
                            this.isLoading = false;
                            resolve();
                        })
                        .catch(err => {
                            this.isLoading = false;
                            if (err.data) {
                                this.$toasted.error(err.data.message);
                                this.$router.push({ name: 'dashboard' });
                            }
                            err = (err.response && err.response.data) ? err.response.data : err;
                            if (err && (err.status_code === 403 || err.status_code === 404)) {
                                this.$router.push({ name: 'dashboard' });
                                this.$toasted.error(err.message);
                            }
                            reject();
                        })
                } else if (this.paramsArray) {
                    this.parameters = _.cloneDeep(this.paramsArray[this.place - 1]);
                    // this.$store.dispatch('setGame', _.cloneDeep(this.parameters));
                    if (!this.$offline && this.user.type === 'student' && !this.inPuzzle) {
                        this.createStat()
                            .then(stat => {
                                this.gameStat = stat;
                                resolve();
                            });
                    } else {
                        resolve();
                    }
                } else if (this.game) {
                    let paramsForGame = this.game.slug !== 'Puzzle' ? this.game : this.game.games[0].parameters.default
                    this.parameters = _.cloneDeep(paramsForGame);
                    if ((this.user.type === 'student' || this.user.type === 'olympiads-student') && !this.inPuzzle) {
                        this.createStat()
                            .then(stat => {
                                this.gameStat = stat;
                                resolve();
                            });
                    } else {
                        resolve();
                    }
                } else {
                    this.$router.push({name: 'dashboard'});
                }
            });
        },
        sendStat (isCorrect) {
            if (!this.parameters || !this.gameStat) {
                return;
            }
            if (this.parameters.isComplication) {
                let amountOfActions = this.initialAmountOfActions;
                let complicatedAmountOfActions = this.parameters.amountOfActions;
                this.gameStat.parameters.amountOfActions = Math.round(amountOfActions/2 + complicatedAmountOfActions/2);
            }
            if (this.parameters.isSpeedIncrease) {
                let speed = this.initialSpeed;
                let increasedSpeed = this.parameters.speed;
                this.gameStat.parameters.speed = +((speed/2 + increasedSpeed/2).toFixed(2));
            }
            if (this.parameters.infinityAmountOfExamples) {
                if (this.type && this.type === 'InteractiveFlashCards') {
                    this.gameStat.parameters.amount = this.answers.good;
                }
                this.gameStat.parameters.amountOfExamples = this.answers.good;
            }
            this.gameStat.attempts = this.answers.good + this.answers.bad;
            this.gameStat.answers = this.answers.good;
            this.gameStat.percent = this.calculatePercent();
            this.gameStat.isCompleted = this.gameEnd;
            this.gameStat.executionTime = this.time !== 0 ? this.time : this.timeBeforeDestroy;
            this.gameStat.example = SEND_EXAMPLE_GAMES.includes(this.type) ? this.example : null;
            this.gameStat.isCorrect = !!isCorrect;
            this.gameStat.isOlympiadLevelTrainer = this.isOlympiad && this.exercise && this.exercise.sourceType === "olympiadLevelTrainerStage";
            this.gameStat.infinityAmountOfExamples = this.parameters.infinityAmountOfExamples;
            this.gameStat.infinityModeCompleted = this.infinityModeCompleted;
            return GameStatsApi.update(this.gameStat.id, this.gameStat)
                .then(data => {
                    this.gameStat.id = data.id;
                    if (data.isCompleted) {
                        if (this.isBattle) {
                            this.$nextTick(() => this.$emit('finish'));
                        } else {
                            this.$emit('finish', data);
                        }
                    } else if (this.isBattle) {
                        setTimeout(this.refreshGame, 2000);
                    }
                })
                .catch(err => {
                    this.$toasted.error(this.$root.$t('errors.saving_results'));
                });
        },
        calculatePercent() {
            let total = this.answers.good + this.answers.bad;
            if (total > 0) {
                return parseInt(this.answers.good / (total) * 100);
            }
            return 0;
        },
        restartGame () {
            this.beforeGameRestart && this.beforeGameRestart();
            Object.assign(this, DEFAULT_DATA);
            clearTimeout(this.counterTimeout);
            this.gameStat = null;
            this.answers.good = 0;
            this.answers.bad = 0;
            this.resetTimer();
            this.fetchData();
        }
    },
    computed: mapState({
        user: state => state.auth.user,
        game: state => state.trainer.game,
        homework: state => state.trainer.homework,
        paramsArray: state => state.trainer.paramsArray
    }),
}
